// GENERATO da informativa/contenuto.py (unica fonte): non modificare a mano.
export const INFORMATIVA = {
  "versione": "2026-10-15",
  "dataTesto": "15 ottobre 2026",
  "titolo": "Informativa sul trattamento dei dati personali",
  "sottotitolo": "Per i condomini che usano la piattaforma condominiale. Articoli 13 e 14 del Regolamento (UE) 2016/679.",
  "riassunto": [
    {
      "titolo": "Perché usiamo i tuoi dati",
      "testo": "Per gestire il condominio: quote, pagamenti, ricevute, convocazioni e verbali. Per farti consultare la tua posizione, scriverci e dichiarare i pagamenti. Per la sicurezza della piattaforma e per gli obblighi di legge. Non li usiamo per marketing, né per profilarti, né per decisioni automatizzate."
    },
    {
      "titolo": "Dove vanno a finire",
      "testo": "Su un server dedicato al servizio presso Aruba S.p.A., in un data center in Italia (Arezzo). Non li portiamo fuori dallo Spazio economico europeo. Li vedono solo l'amministrazione, il fornitore della piattaforma (Artego SRLS) e, per i dati necessari al loro incarico, i professionisti del condominio. Gli altri condomini non vedono la tua posizione contabile."
    },
    {
      "titolo": "Per quanto tempo li conserviamo",
      "testo": "Anagrafica e titolarità: finché sei condomino e per 10 anni dopo. Dati contabili: 10 anni dalla chiusura dell'esercizio. Verbali, convocazioni e delibere: senza limite, sono la memoria storica del condominio. Registro degli accessi: 12 mesi."
    }
  ],
  "sezioni": [
    {
      "id": "titolare",
      "titolo": "1. Chi tratta i tuoi dati",
      "paragrafi": [
        "Il titolare del trattamento è il Condominio Via della Libertà 193, Via della Libertà 193, 90143 Palermo, codice fiscale 97057730828, rappresentato dall'amministratore in carica.",
        "L'amministrazione è affidata a LI.BE. Società Cooperativa, Settore Architettura e Consulenza Condominiale (responsabile di settore: Arch. Giulia Orsini), Via Marchese di Villabianca 114, 90143 Palermo, P.IVA IT06318730824.",
        "Per qualsiasi domanda sui tuoi dati o per esercitare i tuoi diritti puoi scrivere a condominio@libecoop.it, alla PEC condominioliberta193@pec.it, oppure telefonare al +393335201432.",
        "La piattaforma è fornita da Artego SRLS, Via Marchese di Villabianca 114, 90143 Palermo, P.IVA 07221580827, che tratta i dati per conto del condominio, secondo le sue istruzioni, come responsabile del trattamento."
      ]
    },
    {
      "id": "dati",
      "titolo": "2. Quali dati trattiamo e da dove arrivano",
      "paragrafi": [
        "Trattiamo questi dati:"
      ],
      "elenco": [
        "dati identificativi e di contatto: nome e cognome, codice fiscale, email, PEC, telefono;",
        "dati sull'immobile: unità, titolarità (proprietario, usufruttuario o altro) e millesimi;",
        "dati contabili: quote dovute, pagamenti, ricevute, saldi e solleciti;",
        "dati che carichi tu: messaggi, segnalazioni e ricevute di pagamento, che possono contenere anche dati bancari;",
        "dati di accesso: email con cui entri, password (conservata in forma cifrata), data e ora degli accessi e delle azioni compiute nella piattaforma."
      ],
      "dopo": [
        "I dati arrivano da te, dall'assemblea e dai suoi atti, dal precedente amministratore (che ha consegnato l'archivio al passaggio di consegne), dagli atti di proprietà e catastali che ci fornisci e dagli accrediti sul conto corrente del condominio.",
        "Non ti chiediamo categorie particolari di dati, come quelli sulla salute. Se ne scrivi in un messaggio o in un allegato li useremo solo per risponderti."
      ]
    },
    {
      "id": "finalita",
      "titolo": "3. Perché li usiamo",
      "paragrafi": [
        "Questi sono i motivi per cui trattiamo i tuoi dati e la ragione di legge che lo consente (articolo 6, paragrafo 1, del Regolamento):"
      ],
      "tabella": {
        "intestazioni": [
          "Finalità",
          "Base giuridica"
        ],
        "righe": [
          [
            "Gestione amministrativa e contabile del condominio: ripartizione delle spese, quote, incassi, ricevute, rendiconti, convocazioni e verbali.",
            "Obbligo di legge (lettera c) e legittimo interesse del condominio alla corretta gestione delle parti comuni (lettera f)."
          ],
          [
            "Accesso alla piattaforma, consultazione della tua posizione, avvisi, bacheca, segnalazioni e dichiarazione dei pagamenti.",
            "Legittimo interesse del condominio a gestire in modo efficiente e trasparente i rapporti con i condomini (lettera f). Puoi opporti."
          ],
          [
            "Verifica dei pagamenti e riscossione delle quote, anche in caso di morosità.",
            "Obbligo di legge e legittimo interesse (lettere c ed f)."
          ],
          [
            "Adempimenti fiscali e amministrativi, come dichiarazioni e comunicazioni a enti pubblici.",
            "Obbligo di legge (lettera c)."
          ],
          [
            "Sicurezza della piattaforma, prevenzione degli accessi non autorizzati, registro delle operazioni.",
            "Legittimo interesse (lettera f)."
          ],
          [
            "Tutela dei diritti del condominio in sede giudiziaria o stragiudiziale.",
            "Legittimo interesse (lettera f)."
          ]
        ]
      },
      "dopo": [
        "Per questi trattamenti non serve il tuo consenso. Con «Accetto» confermi di aver letto questa informativa: non è un consenso a trattamenti ulteriori.",
        "Non usiamo i tuoi dati per marketing, non facciamo profilazione e non prendiamo decisioni basate solo su trattamenti automatizzati."
      ]
    },
    {
      "id": "destinatari",
      "titolo": "4. Con chi li condividiamo",
      "paragrafi": [
        "I tuoi dati possono essere comunicati a:"
      ],
      "elenco": [
        "l'amministratore e i suoi collaboratori autorizzati;",
        "Artego SRLS, fornitore della piattaforma (responsabile del trattamento);",
        "Aruba S.p.A., che ospita i server e il servizio di posta elettronica;",
        "professionisti e fornitori incaricati dal condominio (per esempio il commercialista, il consulente del lavoro per il personale, le ditte di manutenzione), solo per i dati necessari al loro incarico;",
        "banche e istituti di pagamento, per pagamenti e accrediti;",
        "enti pubblici e autorità, quando la legge lo richiede (per esempio l'Agenzia delle Entrate);",
        "gli altri condomini, solo per ciò che la legge e gli atti condominiali prevedono, come verbali e convocazioni, e per i messaggi che l'amministratore approva e pubblica in bacheca. La tua posizione contabile non è visibile agli altri condomini."
      ],
      "dopo": [
        "Non vendiamo i tuoi dati e non li diffondiamo."
      ]
    },
    {
      "id": "luogo",
      "titolo": "5. Dove vanno a finire i dati",
      "paragrafi": [
        "I dati sono conservati su un server dedicato al servizio presso Aruba S.p.A., in un data center in Italia (Arezzo). Non li trasferiamo fuori dallo Spazio economico europeo.",
        "Le copie di sicurezza (backup) sono conservate dall'amministrazione e dal fornitore con le stesse misure di protezione: accesso con credenziali personali, connessione cifrata (https) e password conservate in forma cifrata."
      ]
    },
    {
      "id": "conservazione",
      "titolo": "6. Per quanto tempo li conserviamo",
      "paragrafi": [
        "Non conserviamo i dati più a lungo del necessario. Questi sono i tempi:"
      ],
      "tabella": {
        "intestazioni": [
          "Tipo di dato",
          "Per quanto tempo"
        ],
        "righe": [
          [
            "Anagrafica e titolarità dell'unità",
            "Finché sei condomino e per 10 anni dopo."
          ],
          [
            "Dati contabili: quote, pagamenti, ricevute, rendiconti, documenti di spesa",
            "10 anni dalla chiusura dell'esercizio a cui si riferiscono."
          ],
          [
            "Verbali, convocazioni, delibere e tabelle millesimali",
            "Senza limite di tempo: sono la memoria storica del condominio."
          ],
          [
            "Messaggi, segnalazioni e ricevute che carichi",
            "10 anni se riguardano pagamenti, altrimenti 5 anni dalla chiusura della pratica."
          ],
          [
            "Registro degli accessi e delle operazioni nella piattaforma",
            "12 mesi."
          ]
        ]
      },
      "dopo": [
        "Alla scadenza i dati vengono cancellati o resi anonimi, salvo che la legge ne imponga o consenta la conservazione ulteriore, per esempio per una controversia in corso."
      ]
    },
    {
      "id": "diritti",
      "titolo": "7. I tuoi diritti",
      "paragrafi": [
        "Puoi chiederci in ogni momento:"
      ],
      "elenco": [
        "di sapere quali dati abbiamo su di te e di averne una copia (articolo 15);",
        "di correggere i dati sbagliati o incompleti (articolo 16);",
        "di cancellarli, quando non servono più o la legge lo consente (articolo 17);",
        "di limitarne l'uso in certi casi (articolo 18);",
        "di riceverli in un formato leggibile da un computer (articolo 20);",
        "di opporti al trattamento fondato sul legittimo interesse (articolo 21)."
      ],
      "dopo": [
        "Scrivi ai recapiti del punto 1: risponderemo entro un mese. Se pensi che i tuoi dati non siano trattati correttamente puoi presentare reclamo al Garante per la protezione dei dati personali (articolo 77), www.garanteprivacy.it."
      ]
    },
    {
      "id": "obbligo",
      "titolo": "8. Se non fornisci i dati",
      "paragrafi": [
        "Alcuni dati servono per gestire il condominio e per attivare il tuo accesso alla piattaforma: senza di essi non possiamo darti l'accesso. Questo non toglie nulla ai tuoi diritti di condomino: le informazioni dell'amministrazione ti arrivano comunque per le vie ordinarie, come posta e avvisi."
      ]
    },
    {
      "id": "cookie",
      "titolo": "9. Cookie",
      "paragrafi": [
        "La piattaforma usa solo strumenti tecnici necessari al funzionamento e all'accesso. Non usa cookie di profilazione né strumenti di tracciamento pubblicitario."
      ]
    },
    {
      "id": "aggiornamenti",
      "titolo": "10. Aggiornamenti",
      "paragrafi": [
        "Questa è la versione del 15 ottobre 2026. Se cambierà in modo rilevante, alla prossima visita ti chiederemo di leggerla di nuovo."
      ]
    }
  ],
  "testoAccettazione": "Ho letto l'informativa completa sul trattamento dei dati personali e ne accetto il contenuto."
};
